const handlefollowBrand = async (userId, brandId) => {
  console.log("Sender of request", userId);
  console.log("Brand of request (brand to follow)", brandId);

  try {
    const response = await fetch(
      process.env.REACT_APP_API + "/api/followBrand",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ brandId, userId }),
      }
    );

    await response.json();
    console.log("followed brand successfully!");
  } catch (error) {
    console.error("Error updating document: ", error);
  }

  return true;
};
export default handlefollowBrand;
